import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Products from '../product/Products';

const MarketDashboard = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12} className="d-flex justify-content-between">
          <h3 className="page-title mb-3">Marketplace Dashboard</h3>
          <Link to="/dashboard">
            <button type="button" className="btn btn-primary purple-button">
              Switch To Wallet Dashboard
            </button>
          </Link>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Products />
        </Col>
      </Row>
    </Container>
  );
};

export default MarketDashboard;

